export default __webpack_public_path__ + "static/media/chronos-sm-white.d9f5e5fe.svg";